/*eslint-disable react/no-danger*/
require('./index.scss')
import { useSelector } from 'react-redux'

import {
  PRINT_VARIANTS,
  returnPolicyExplanationTextSelector,
  selectedPrintVariantSelector
} from '@/selectors'
import { translate } from '@/utils/translations'

import ReturnPolicyModal from './ReturnPolicyModal'

const TRANSLATION_KEY = 'return_policy.pdp_tab'

const PolicyStatementPrint = () => {
  const currentPolicyText = useSelector(returnPolicyExplanationTextSelector)
  const isBulkEnabled = useSelector(state => state.currentRegion.bulkEnabled)
  const selectedPrintVariant = useSelector(selectedPrintVariantSelector)
  const selectedVariant = useSelector(state => state.asset.selectedVariant)
  const isNotReturnable = selectedVariant?.isReturnable === false

  const displayNotReturnable = isNotReturnable
    && [PRINT_VARIANTS.NEW, PRINT_VARIANTS.USED].includes(selectedPrintVariant)

  if (selectedPrintVariant === PRINT_VARIANTS.MARKETPLACE) {
    return (
      <>
        <span dangerouslySetInnerHTML={{
            __html: translate(`${TRANSLATION_KEY}.marketplace_not_returnable`)
          }}
        />
        <ReturnPolicyModal />
      </>
    )
  }

  if (displayNotReturnable) {
    return (
      <>
        <span dangerouslySetInnerHTML={{
            __html: translate(`${TRANSLATION_KEY}.not_returnable`)
          }}
        />
        {' '}
      </>
    )
  }

  return (
    <>
      {translate(`${TRANSLATION_KEY}.easy`)}
      <If condition={!isBulkEnabled}>
        {translate(`${TRANSLATION_KEY}.days`, { days: 30 })}
        {translate(`${TRANSLATION_KEY}.returns`)}
      </If>
      <ReturnPolicyModal />
      {currentPolicyText}
    </>
  )
}

export default PolicyStatementPrint
